import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FlightTakeoffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"flight_takeoff"}/>
}
